import { Component, EventEmitter, OnInit, Output, signal } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { EmpresaPicker } from '../../../components/empresa-picker/empresa-picker';
import { SelecionarEmpresaModal } from '../../../modals/selecionar-empresa-modal/selecionar-empresa-modal';
import { DesvincularEmpresa } from '../../pessoas/cadastrar-pessoa/dialogs/desvincular-empresa/desvincular-empresa';
import { SelecionarEnderecoModal } from '../../../modals/selecionar-endereco-modal/selecionar-endereco-modal';
import { DesvincularEndereco } from '../../pessoas/cadastrar-pessoa/dialogs/desvincular-endereco/desvincular-endereco';
import axiosClient from '../../../../shared/axios/axios-client';
import { environment } from '../../../../environments/environment';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { SelecionarPessoaModal } from '../../../modals/selecionar-pessoa-modal/selecionar-pessoa-modal';
import { DesvincularPessoaModal } from '../../../modals/desvincular-pessoa-modal/desvincular-pessoa-modal';
import { SnackbarService } from '../../../services/snackbar/snackbar.service';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import axios from 'axios';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MoviaService } from '../../../services/movia/movia.service';
import { ModalConfirmadoEnvioAnalise } from '../modal-confirmado-envio-analise/modal-confirmado-envio-analise';

@Component({
  selector: 'app-analise-postural',
  standalone: true,
  imports: [
    EmpresaPicker,
    MatDialogModule,
    MatButtonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    MatRadioModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './analise-postural.html',
  styleUrl: './analise-postural.scss',
})
export class AnalisePostural {
  constructor(
    private dialog: MatDialog,
    private snackbarService: SnackbarService,
    private moviaService: MoviaService,
  ) {}

  @Output() mudarTela = new EventEmitter<1 | 2>();

  processando = false;

  empresaSelecionada: any = null;
  enderecoSelecionado: any = null;
  pessoaSelecionada: any = null;
  cargaSelecionada: any = null;
  arquivoSelecionado: any = signal(null);

  urlAzure: {
    uploadUrl: string;
    fileName: string;
  } | null = null;

  touchedEmpresa = false;
  touchedEndereco = false;
  touchedPessoa = false;
  touchedArquivo = false;

  formBloqueado = signal(false);

  empresasOptions: any[] = [];
  pessoasOptions: any[] = [];
  cargaOptions: string[] = ['Sem carga', 'Leve', 'Moderada', 'Pesada'];

  onSelecaoAlterada(event: any) {
    this.empresaSelecionada = event.empresa;
    this.enderecoSelecionado = event.endereco;

    if (!this.empresaSelecionada) {
      this.enderecoSelecionado = null;
      this.pessoaSelecionada = null;
    }

    if (!this.enderecoSelecionado) {
      this.pessoaSelecionada = null;
    }
  }

  async abrirModalPessoasEndereco() {
    await this.buscarPessoasVinculadasAoEndereco();

    this.touchedPessoa = true;
    const dialogRef = this.dialog.open(SelecionarPessoaModal, {
      data: {
        pessoas: this.pessoasOptions,
        pessoaSelecionada: this.pessoaSelecionada,
      },
    });
    dialogRef.afterClosed().subscribe((pessoa: any) => {
      if (pessoa) this.pessoaSelecionada = pessoa;
    });
  }

  abriDesvincularPessoa() {
    const dialogRef = this.dialog.open(DesvincularPessoaModal, {
      width: '400px',
      data: {
        pessoa: this.pessoaSelecionada,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.pessoaSelecionada = null;
        this.snackbarService.success('Pessoa desvinculada com sucesso!');
      }
    });
  }

  async buscarPessoasVinculadasAoEndereco() {
    let id = this.enderecoSelecionado.idEstabelecimento;
    return await axiosClient
      .get(`${environment.apiUrl}/estabelecimento/${id}/pessoas`)
      .then((res) => {
        this.pessoasOptions = res.data.data;
      })
      .catch((err) => {
        throw err;
      });
  }

  onArquivoSelecionado(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const arquivo = input.files[0];

      if (!this.validarTipoArquivo(arquivo)) {
        this.snackbarService.error(
          'Formato inválido. Arquivos permitidos: mp4, avi, mov.',
        );
        input.value = '';
        return;
      }

      if (!this.validarTamanhoArquivo(arquivo, 600)) {
        this.snackbarService.error('O arquivo deve ter no máximo 600MB.');
        input.value = '';
        return;
      }

      this.arquivoSelecionado.set(arquivo);
      this.touchedArquivo = true;
    }
  }

  validarTipoArquivo(arquivo: File): boolean {
    const tiposPermitidos = [
      'video/mp4',
      'video/x-msvideo', // avi
      'video/quicktime', // mov
    ];

    return (
      tiposPermitidos.includes(arquivo.type) ||
      arquivo.name.toLowerCase().match(/\.(mp4|avi|mov)$/) !== null
    );
  }

  validarTamanhoArquivo(arquivo: File, maxMB: number): boolean {
    const maxBytes = maxMB * 1024 * 1024;
    return arquivo.size <= maxBytes;
  }

  removerArquivo(): void {
    this.arquivoSelecionado.set(null);
    this.touchedArquivo = false;

    // Limpar o input file
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  formularioValido(): boolean {
    return !!(
      this.empresaSelecionada &&
      this.enderecoSelecionado &&
      this.arquivoSelecionado()
    );
  }

  formatarTamanhoArquivo(bytes: number): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  }

  abrirSeletorArquivo(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  private cargaMap: Record<string, number> = {
    'Sem carga': 0,
    Leve: 1,
    Moderada: 2,
    Pesada: 3,
  };

  async salvar() {
    this.touchedEmpresa = true;
    this.touchedEndereco = true;
    this.touchedPessoa = true;
    this.touchedArquivo = true;

    if (!this.formularioValido()) return;

    this.processando = true;
    this.formBloqueado.set(true);

    try {
      const arquivo = this.arquivoSelecionado();

      // URL de upload no Azure
      const resUrl = await this.moviaService.gerarUrlUploadAzure(arquivo.name);
      const { uploadUrl, fileName, correlationId } = resUrl.data.data;

      // Envio para Azure
      await this.moviaService.enviarVideoParaAzure(uploadUrl, arquivo);

      // Iniciar processamento
      await this.moviaService.iniciarProcessamento(
        uploadUrl,
        arquivo,
        correlationId,
        arquivo.name,
        this.enderecoSelecionado?.idEstabelecimento ?? null,
        this.pessoaSelecionada?.idPessoa ?? null,
        this.cargaSelecionada != null
          ? this.cargaMap[this.cargaSelecionada]
          : null,
      );
      this.snackbarService.success('Vídeo enviado para análise com sucesso!');

      this.abrirModalConfirmadoEnvio();
      this.resetarFormulario();
    } catch {
      this.snackbarService.error('Erro ao enviar o vídeo. Tente novamente.');
      this.formBloqueado.set(false);
    } finally {
      this.processando = false;
    }
  }

  resetarFormulario() {
    this.empresaSelecionada = null;
    this.enderecoSelecionado = null;
    this.pessoaSelecionada = null;
    this.cargaSelecionada = null;
    this.arquivoSelecionado.set(null);
    this.touchedEmpresa = false;
    this.touchedEndereco = false;
    this.touchedPessoa = false;
    this.touchedArquivo = false;
    this.formBloqueado.set(false);
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }

  abrirModalConfirmadoEnvio() {
    const dialogRef = this.dialog.open(ModalConfirmadoEnvioAnalise, {
      width: '400px',
      data: {},
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.mudarTela.emit(2);
    });
  }
}
